module.exports = __webpack_public_path__ + "fonts/Figtree-580.b098e71.woff2";